import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FormControl, FormLabel, Stack, Typography, useTheme } from '@mui/material';

import IconWithTooltip from '../IconWithTooltip/IconWithTooltip';

import type { FieldProps } from './types';

export const Field = (props: FieldProps) => {
  const {
    orientation = 'vertical',
    size,
    tooltip,
    label,
    fullWidth,
    required,
    validationState = 'none',
    validationMessage,
    showValidationMessageIcon,
    children,
  } = props;
  const theme = useTheme();
  return (
    <FormControl fullWidth={fullWidth} variant="outlined" size={size}>
      <Stack direction="column" spacing={1}>
        <Stack
          direction={orientation === 'vertical' ? 'column' : 'row'}
          spacing={1}
          sx={{ alignItems: orientation === 'vertical' ? undefined : 'center' }}
        >
          <FormLabel>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <Typography variant="body2" color={theme.palette.text.primary}>
                {label}
              </Typography>
              {tooltip && <IconWithTooltip tooltipTitle={tooltip} icon={<InfoOutlinedIcon />} />}
              {required && (
                <Typography variant="caption" color={theme.palette.error.light}>
                  *
                </Typography>
              )}
            </Stack>
          </FormLabel>
          {children}
        </Stack>
        {validationState === 'error' && validationMessage && (
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            {showValidationMessageIcon && <ErrorOutlineIcon color="error" fontSize="small" />}
            <Typography variant="caption" color={theme.palette.error.main}>
              {validationMessage}
            </Typography>
          </Stack>
        )}
      </Stack>
    </FormControl>
  );
};
